export function getCookieByName(cookieName: string) {
    if (typeof document === 'undefined' || document == null || !document || !document.cookie) {
        return null;
    }

    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            const output = c.substring(name.length, c.length);
            return (!!output ? output : null);      
        }
    }
    return null;
}

export function setSessionCookie(cname: string, cvalue: string) {
    if (typeof document === 'undefined' || !document || !document.cookie) {
        return;
    }

    const domain = getDomain();
    document.cookie = `${cname}=${cvalue};domain=.${domain};path=/`;
}

// expiry in seconds
export function setCookie(cname: string, cvalue: string, expiry: number) {
    if (typeof document === 'undefined' || !document || !document.cookie) {
        return;
    }

    const domain = getDomain();
    let expires = 'Fri, 31 Dec 9999 23:59:59 GMT';

    if (expiry > 0) {
        const dateExpiry = new Date();
        dateExpiry.setTime(dateExpiry.getTime() + expiry * 1000); // convert seconds to milliseconds
        expires = dateExpiry.toUTCString();
    }

    document.cookie = `${cname}=${cvalue};expires=${expires};domain=.${domain};path=/`;
}

// expiry as date
export function setCookieExpiryDate(cname: string, cvalue: string, expires: string) {
    if (typeof document === 'undefined' || !document || !document.cookie) {
        return;
    }

    const domain = getDomain();
    document.cookie = `${cname}=${cvalue};expires=${expires};domain=.${domain};path=/`;
}

function getDomain() {
    return window.location.origin.replace(/(https?:\/\/)?(www.)?/i, '');
}

export function deleteCookie(name: string) {
    const domain = getDomain();
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`;
}

export function setUserCookies(accessToken: string, expiry: string, expiresIn: number, sessionId: string, refreshToken: string, culture: string) {
	setCookieExpiryDate('EWLoginUserDetails', 'LoginUserApiSessionId=' + sessionId, expiry);
	setCookieExpiryDate('EWUserCulture', culture, expiry);
	setCookie('EWUserAccessToken', accessToken, expiresIn);
	setCookieExpiryDate('EWUserRefreshToken', refreshToken, expiry);
}